export const FUNCTIONALITY_TYPES = {
    searchPage: 'searchPage',
    home: 'home',
    dashboard: 'dashboard',
    uiPlayground: 'ui-playground',
    search: 'search',
    searchApp: 'searchapp',
    category: 'category',
    suggest: 'suggest',
    synonym: 'synonym',
    redirect: 'redirect',
    content: 'content',
    abTesting: 'abtesting',
    searchlab: 'searchlab',
    curator: 'curator',
    queryRule: 'query-rule',
    dependency: 'dependency',
    monitoring: 'monitoring',
    webMonitoring: 'webmonitoring',
    systemMonitoring: 'system-monitoring',
    index: 'index',
    indexStorage: 'index-storage',
    vectorizer: 'vectorizer',
    analyzer: 'analyzer',
    feeding: 'feeding',
    widget: 'widget',
    query: 'query',
    template: 'template',
    config: 'config',
    assets: 'assets',
    textExtract: 'text-extract',
    alias: 'alias',
    navigation: 'navigation',
    dictionary: 'dictionary',
    formAssist: 'formassist',
    sitemapBuilder: 'sitemapbuilder',
    tenant: 'tenant',
    role: 'role',
    user: 'user',
    apiMapper: 'api-mapper',
    questionAnswering: 'questionanswering',
    posTagger: 'postagger',
    schedule: 'schedule',
    queueUp: 'queueup',
    list: 'list',
    shortUrl: 'shorturl',
    queryBuilder: 'query-builder',
    templateBuilder: 'template-builder',
    recommendation: 'recommendation',
    judgement: 'judgement',
    expimp: 'expimp',
    security: 'security',
    facet: 'facet',
    idMapping : 'id-mapping',
    apiTesting : 'api-testing',
    reporting : 'reporting',
    entityManager: 'entity-manager',
    componentConfigManager: 'componentConfigManager'
}
